/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.tool.access.rpc.ToolAccessService
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './ToolAccessService';
import * as Queries from './ToolAccessService.dfc.new';
import type { AdditionalContextArgs } from './ToolAccessService.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseRequestToolAccessMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.RequestToolAccessResponseType>,
    References.RequestToolAccessRequestType,
    T extends true
      ? Record<'requestToolAccess', References.RequestToolAccessResponseType>
      : References.RequestToolAccessResponseType
  >;

export function useRequestToolAccessMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.RequestToolAccessResponseType>,
    References.RequestToolAccessRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseRequestToolAccessMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.REQUEST_TOOL_ACCESS_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            requestToolAccess: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseRequestToolAccessMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseRequestToolAccessMutationReturn<T>;
}

type UseGetActiveToolAccessRequestForScopeQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetActiveToolAccessRequestForScopeResponseType>,
    References.GetActiveToolAccessRequestForScopeRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getActiveToolAccessRequestForScope',
            References.GetActiveToolAccessRequestForScopeResponseType
          >
        : References.GetActiveToolAccessRequestForScopeResponseType)
    | undefined;
};

export function useGetActiveToolAccessRequestForScopeQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.GetActiveToolAccessRequestForScopeResponseType>,
    References.GetActiveToolAccessRequestForScopeRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetActiveToolAccessRequestForScopeQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_ACTIVE_TOOL_ACCESS_REQUEST_FOR_SCOPE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getActiveToolAccessRequestForScope: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetActiveToolAccessRequestForScopeQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetActiveToolAccessRequestForScopeQueryReturn<T>;
}

type UseGetActiveToolAccessRequestForScopeLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetActiveToolAccessRequestForScopeResponseType>,
    References.GetActiveToolAccessRequestForScopeRequestType,
    T extends true
      ? Record<
          'getActiveToolAccessRequestForScope',
          References.GetActiveToolAccessRequestForScopeResponseType
        >
      : References.GetActiveToolAccessRequestForScopeResponseType
  >;

export function useGetActiveToolAccessRequestForScopeLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetActiveToolAccessRequestForScopeResponseType>,
    References.GetActiveToolAccessRequestForScopeRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetActiveToolAccessRequestForScopeLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_ACTIVE_TOOL_ACCESS_REQUEST_FOR_SCOPE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getActiveToolAccessRequestForScope: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetActiveToolAccessRequestForScopeLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetActiveToolAccessRequestForScopeLazyQueryReturn<T>;
}

type UseGetActiveToolAccessRequestForScopeSuspenseQueryReturn<
  T extends boolean,
> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetActiveToolAccessRequestForScopeResponseType>,
    References.GetActiveToolAccessRequestForScopeRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getActiveToolAccessRequestForScope',
        References.GetActiveToolAccessRequestForScopeResponseType
      >
    : References.GetActiveToolAccessRequestForScopeResponseType;
};

export function useGetActiveToolAccessRequestForScopeSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetActiveToolAccessRequestForScopeResponseType>,
    References.GetActiveToolAccessRequestForScopeRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetActiveToolAccessRequestForScopeSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_ACTIVE_TOOL_ACCESS_REQUEST_FOR_SCOPE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getActiveToolAccessRequestForScope: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetActiveToolAccessRequestForScopeSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetActiveToolAccessRequestForScopeSuspenseQueryReturn<T>;
}
